<div class="highcharts-tooltip">
  <span>
    <div
      class="metric-tooltip school_comp_description body_tooltip_text mz-table-tooltip-descriptor"
    >
      <strong>{{ numerator | number }}</strong>
      <ng-container *ngIf="denominator">
        of
        <strong>{{ denominator | number }}</strong>
      </ng-container>
      {{ descriptor }}
    </div>
  </span>
</div>
